import { useState } from 'react';
import { useGame } from '../store/game';
import { useOnline } from '../store/online';

export function CreateRoom() {
  const go = useGame((s) => s.go);
  const { create, status, error } = useOnline();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  return (
    <div className="page" style={{ maxWidth: 480 }}>
      <h1 style={{ fontSize: '2.2rem' }}>Criar sala</h1>
      <p className="muted">Você vira o anfitrião e recebe um código para compartilhar.</p>
      <form
        className="stack"
        onSubmit={(e) => {
          e.preventDefault();
          if (name.trim()) create(name.trim(), password);
        }}
      >
        <div className="field">
          <label htmlFor="c-name">Seu nome</label>
          <input id="c-name" className="input" value={name} maxLength={20} onChange={(e) => setName(e.target.value)} autoFocus required />
        </div>
        <div className="field">
          <label htmlFor="c-pass">Senha (opcional)</label>
          <input id="c-pass" className="input" type="password" value={password} maxLength={64} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="error-box">{error}</div>}
        <div className="row" style={{ marginTop: '0.5rem' }}>
          <button type="button" className="btn" onClick={() => go('home')}>
            Voltar
          </button>
          <span className="spacer" />
          <button className="btn primary" disabled={!name.trim() || status === 'connecting'}>
            {status === 'connecting' ? 'Conectando…' : 'Criar sala'}
          </button>
        </div>
      </form>
    </div>
  );
}

export function JoinRoom() {
  const go = useGame((s) => s.go);
  const { join, status, error } = useOnline();
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  return (
    <div className="page" style={{ maxWidth: 480 }}>
      <h1 style={{ fontSize: '2.2rem' }}>Entrar numa sala</h1>
      <form
        className="stack"
        onSubmit={(e) => {
          e.preventDefault();
          if (code.trim() && name.trim()) join(code.trim().toUpperCase(), name.trim(), password);
        }}
      >
        <div className="field">
          <label htmlFor="j-code">Código da sala</label>
          <input
            id="j-code"
            className="input"
            value={code}
            maxLength={6}
            onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))}
            style={{ letterSpacing: '0.2em', fontSize: '1.3rem', textTransform: 'uppercase' }}
            autoFocus
            required
            autoComplete="off"
          />
        </div>
        <div className="field">
          <label htmlFor="j-name">Seu nome</label>
          <input id="j-name" className="input" value={name} maxLength={20} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="field">
          <label htmlFor="j-pass">Senha (se a sala tiver)</label>
          <input id="j-pass" className="input" type="password" value={password} maxLength={64} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="error-box">{error}</div>}
        <div className="row" style={{ marginTop: '0.5rem' }}>
          <button type="button" className="btn" onClick={() => go('home')}>
            Voltar
          </button>
          <span className="spacer" />
          <button className="btn primary" disabled={code.length !== 6 || !name.trim() || status === 'connecting'}>
            {status === 'connecting' ? 'Conectando…' : 'Entrar'}
          </button>
        </div>
      </form>
    </div>
  );
}
